var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-vpt-view"},[_c('StockVPT')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }